import { render } from "./VerifyOtpPage.vue?vue&type=template&id=8c4bd466&scoped=true"
import script from "./VerifyOtpPage.vue?vue&type=script&lang=js"
export * from "./VerifyOtpPage.vue?vue&type=script&lang=js"

import "./VerifyOtpPage.vue?vue&type=style&index=0&id=8c4bd466&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c4bd466"]])

export default __exports__